import { CircularProgress, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { PrincipalLayouts } from "../../../layouts";
import { fetchData } from "../../helpers/getData/fetchData";
import { PositionViewTable } from "./PositionViewTable";

export const PositionView = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { t } = useTranslation("global");
  const [rows, setRows] = useState("isLoading");
  const [reloadData, setReloadData] = useState(false);
  const [vehiclesList, setVehicles] = useState("isLoading");

  useEffect(() => {
    fetchData(
      setRows,
      `/investments/getByOportunity?opportunity=${searchParams.get(
        "opportunity"
      )}`,
      t
    );
    fetchData(setVehicles, "/vehicle/nameList", t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadData, t]);

  return (
    <PrincipalLayouts>
      {rows !== "isLoading" && vehiclesList !== "isLoading" ? (
        <PositionViewTable
          rows={rows}
          setReloadData={setReloadData}
          name={searchParams.get("name")}
          vehiclesList={vehiclesList}
        />
      ) : (
        <Stack width="100%" alignItems="center" marginTop="100px">
          <CircularProgress />
        </Stack>
      )}
    </PrincipalLayouts>
  );
};
